import {useEffect,useState} from 'react';
import {api,ApiError} from '../api';
import {withBuildingScope} from '../ui/building-scope';

type Failure={id:string;message_id:string;subject:string};

/**
 * Shown on a conversation when BlockGenie could not finish processing one of its messages. It says so in plain words
 * and offers Retry. It appears only when a failure has been recorded, so a healthy conversation is unchanged.
 */
export function MailProcessingNotice({threadId,building,canRetry}:{threadId:string;building:string|undefined;canRetry:boolean}){
 const [failures,setFailures]=useState<Failure[]>([]),[busy,setBusy]=useState(false),[result,setResult]=useState<{kind:'success'|'error';text:string}>();
 const load=async()=>{
  try{const page=await api<{items:Failure[]}>(withBuildingScope(`/api/mail-processing/failures?thread=${encodeURIComponent(threadId)}`,building));setFailures(page.items);}
  catch{setFailures([]);}
 };
 useEffect(()=>{void load();},[threadId,building]);
 async function retry(){
  setBusy(true);setResult(undefined);
  try{
   const outcome=await Promise.all(failures.map(failure=>api<{requeued:number}>(`/api/mail-processing/${failure.message_id}/retry`,{method:'POST',body:JSON.stringify({})})));
   setResult({kind:'success',text:outcome.some(o=>o.requeued>0)?'Processing has been queued again. This notice clears when it succeeds.':'Nothing was waiting to retry.'});
   await load();
  }catch(error){setResult({kind:'error',text:error instanceof ApiError?error.message:'Processing could not be retried. Try again, or deal with the message manually.'});}
  finally{setBusy(false);}
 }
 if(!failures.length&&!result)return null;
 return <section className="panel mail-processing-notice" aria-label="Mail processing">
  {failures.length>0&&<><h2>This mail could not be processed</h2>
   <p>BlockGenie tried several times and could not finish processing {failures.length===1?'this message':'these messages'}. Retry it. If it fails again, deal with the message manually.</p>
   {canRetry&&<button type="button" disabled={busy} onClick={()=>void retry()}>Retry processing</button>}</>}
  {result&&<p role={result.kind==='error'?'alert':'status'}>{result.text}</p>}
 </section>;
}
